import { useScrollReveal } from "../../hooks/useScrollReveal";

export function revealItemProps(index, className = "") {
  return {
    className: `landing-scroll-reveal__item ${className}`.trim(),
    style: { "--reveal-index": index },
  };
}

function ScrollReveal({
  as: Component = "div",
  children,
  className = "",
  variant = "up",
  stagger = false,
  threshold,
  rootMargin,
}) {
  const { ref, inView } = useScrollReveal({ threshold, rootMargin });

  const variantClass =
    variant === "from-start"
      ? " landing-scroll-reveal--from-start"
      : variant === "from-end"
        ? " landing-scroll-reveal--from-end"
        : "";

  const classNames = [
    "landing-scroll-reveal",
    stagger && "landing-scroll-reveal--stagger",
    variantClass.trim(),
    inView && "landing-scroll-reveal--visible",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Component ref={ref} className={classNames}>
      {children}
    </Component>
  );
}

export default ScrollReveal;
